import React, { FC } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { GridRenderCellParams } from '@mui/x-data-grid/models/params/gridCellParams';
import { GridTooltip } from '../General/GridTooltip';
import { ISubscriptionRoleResult } from '../../types/subscription-role';

interface SubscriptionRoleResultsDataGridProps {
  searchResults: ISubscriptionRoleResult[] | null;
  loading: boolean;
  totalCount: number;
  page: number;
  pageSize: number;
  onPageChange: (newPage: number) => void;
  onPageSizeChange: (newPageSize: number) => void;
}

const SubscriptionRoleResultsDataGrid: FC<SubscriptionRoleResultsDataGridProps> = ({
  searchResults,
  loading,
  totalCount,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
}) => {
  const navigate = useNavigate();
  const selectUser = (user: ISubscriptionRoleResult) => {
    navigate(`../user/detail/${user.identityId}`);
  };

  const columns: GridColDef[] = [
    {
      field: 'identityId',
      headerName: 'Identity ID',
      minWidth: 260,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => <GridTooltip params={params} />,
    },
    {
      field: 'email',
      headerName: 'Email',
      minWidth: 300,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => <GridTooltip params={params} />,
    },
    {
      field: 'firstName',
      headerName: 'First name',
      minWidth: 100,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => <GridTooltip params={params} />,
    },
    {
      field: 'lastName',
      headerName: 'Last name',
      minWidth: 100,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => <GridTooltip params={params} />,
    },
    {
      field: 'roleName',
      headerName: 'Role',
      minWidth: 120,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => <GridTooltip params={params} />,
    },
  ];

  const pageOptions = [10, 15, 20];

  return (
    searchResults && (
      <DataGrid
        autoHeight
        columns={columns}
        getRowId={(row) => row.identityId}
        loading={loading}
        onRowClick={(row) => selectUser(row.row)}
        rows={searchResults}
        pagination
        paginationMode="server"
        rowCount={totalCount}
        paginationModel={{ page, pageSize }}
        onPaginationModelChange={({ page, pageSize }) => {
          onPageChange(page);
          onPageSizeChange(pageSize);
        }}
        pageSizeOptions={pageOptions}
        sx={{
          backgroundColor: 'white',
          '& .MuiDataGrid-row:hover': {
            cursor: 'pointer',
          },
        }}
      />
    )
  );
};

export default SubscriptionRoleResultsDataGrid;
